// Compile regexes once at module level for better performance
const UUID_PATTERN = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'

const MOBILE_REGEXES = [
  /^\/$/, // Root path
  /^\/tasks(\/.*)?$/, // Tasks paths
  /^\/requests(?:\/[^\/]+)?$/, // /requests/[mode]
  /^\/renewals(?:\/[^\/]+)?$/, // /renewals/[filter]
  /^\/agreements(?:\/[^\/]+)?$/, // /agreements/[filter]
  new RegExp(`^\/agreements\/detail\/${UUID_PATTERN}(?:\/(?:overview|submissions|documents|hierarchy))?$`),
  new RegExp(`^\/agreements\/detail\/${UUID_PATTERN}\/submissions\/${UUID_PATTERN}$`),
  new RegExp(`^\/requests\/detail\/${UUID_PATTERN}\/[^\/]+$`), // /requests/detail/[id]/[tab]
  new RegExp(`^\/requests\/detail\/${UUID_PATTERN}\/risks\/[^\/]+$`), // /requests/detail/[id]/risks/[section]
  new RegExp(`^\/requests\/detail\/${UUID_PATTERN}\/my-tasks\/${UUID_PATTERN}$`), // /requests/detail/[id]/my-tasks/[taskIdOrFormId]
  new RegExp(`^\/requests\/detail\/${UUID_PATTERN}\/submissions\/${UUID_PATTERN}$`), // /requests/detail/[id]/submissions/[requestFormId]
  new RegExp(`^\/requests\/detail\/${UUID_PATTERN}\/submissions\/tasks\/${UUID_PATTERN}$`), // /requests/detail/[id]/submissions/tasks/[taskId]
  /^\/choose-organisation$/, //  /choose-organisation
  /^\/login$/, // /login
  /^\/start(\/.*)?$/, // New request page
  /^\/intake(\/.*)?$/, // Intake forms
  /^\/product-catalogue(\/.*)?$/, // Product catalogue
  /^\/products-and-services(\/.*)?$/, // Products and services
  new RegExp(`^\/hosted-catalogues\/${UUID_PATTERN}\/browse$`), // /hosted-catalogues/[catalogueId]/browse
  /^\/settings\/notifications$/, // Notification settings
  /^\/settings\/preferences$/, // Notification settings
  /^\/ai(\/.*)?$/, // Chat page
  /^\/supplier-onboarding(\/.*)?$/, // Supplier portal
]

export const isSupportedMobileRoute = (pathname: string) => {
  // Check regexes first
  const pathMatches = MOBILE_REGEXES.some((regex) => regex.test(pathname))

  if (pathMatches) {
    return true
  }

  return false
}

export const useIsSupportedMobileRoute = () => {
  if (typeof window === 'undefined') return false

  return isSupportedMobileRoute(window.location.pathname)
}
